import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import configureStore from "./store/configureStore";
import { createBrowserHistory } from "history";
import KeycloakAdaptor from "./keycloak";
import App from "./app";

// Store Initialization
// ------------------------------------
const history = createBrowserHistory();
const store = configureStore(history, window.__INITIAL_STATE__);

// Render Setup
// ------------------------------------
const render = () => {
  KeycloakAdaptor.initKeycloak(() => {
    createRoot(document.getElementById("root")).render(<App history={history} store={store} />);
  });
};

if (process.env.NODE_ENV !== "test") render();
